import ListItem from '@tiptap/extension-list-item';

export default ListItem.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            style: {
                default: null,
            },
            class: {
                default: null,
            },
            id: {
                default: null,
            },
        };
    },
});
